// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

// ** Axios Imports
import axios from "axios"

// ** Constants
import { API_VARIANTS_URL } from "../constants"

export const getListVariants = createAsyncThunk(
    "variants/getListVariants",
    async ({
        page = 1,
        limit = 20,
        search,
        noPaginate,
        company
    } = {}) => {

        let queryParams = `page=${page}&limit=${limit}`
        if (search) {
            queryParams += `&search=${search}`
        }
        if (noPaginate) {
            queryParams += `&noPaginate=true`
        }
        if (company) {
            queryParams += `&company=${company}`
        }
        const response = await axios.get(`${API_VARIANTS_URL}?${queryParams}`)
        return response.data
    }
)

export const getListVariantsSelect = createAsyncThunk(
    "variants/getListVariantsSelect",
    async ({
        page = 1,
        limit = 20,
        search,
        noPaginate,
        company
    } = {}) => {

        let queryParams = `page=${page}&limit=${limit}`
        if (search) {
            queryParams += `&search=${search}`
        }
        if (noPaginate) {
            queryParams += `&noPaginate=true`
        }
        if (company) {
            queryParams += `&company=${company}`
        }
        const response = await axios.get(`${API_VARIANTS_URL}?${queryParams}`)
        return response.data
    }
)

export const getVariantById = createAsyncThunk(
    "variants/getVariantById",
    async (id, { dispatch, getState }) => {
        const response = await axios.get(
            `${API_VARIANTS_URL}/${id}`
        )
        return response.data
    }
)

export const storeVariant = createAsyncThunk(
    "variants/storeVariant",
    async (data, { dispatch, getState }) => {
        const response = await axios.post(
            `${API_VARIANTS_URL}`,
            data
        )
        return response.data
    }
)

export const updateVariant = createAsyncThunk(
    "variants/updateVariant",
    async (data, { dispatch, getState }) => {
        const response = await axios.put(
            `${API_VARIANTS_URL}/${data._id}`,
            data
        )
        return response.data
    }
)

export const variantsSlice = createSlice({
    name: "variants",
    initialState: {
        list: [],
        totalPages: 1,
        loading: true,
        hasNextPage: false,
        pagingCounter: 0,
        totalDocs: 0
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getListVariants.pending, (state, action) => {
                state.loading = true
            })
            .addCase(getListVariants.fulfilled, (state, action) => {
                state.list = action.payload.docs || action.payload
                state.totalPages = action.payload.totalPages
                state.hasNextPage = action.payload.hasNextPage
                state.pagingCounter = action.payload.pagingCounter
                state.totalDocs = action.payload.totalDocs
                state.loading = false
            })
    }
})

export default variantsSlice.reducer
